import { useMount } from '@tiger/hooks';
import { observer } from 'mobx-react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Footer from 'components/DisclosureFooter';
import Progress from 'components/OpenProgress';
import security from 'stores/security';
import values from 'stores/values';
import { CustomerProcessStatusEnum } from 'types/customer';
import { getOpenCacheKey } from 'utils/helper';
import Agreements from './Agreements';
import BaseInfo from './BaseInfo';
import Complete from './Complete';
import Contact from './Contact';
import Invest from './Invest';
import Job from './Job';
import Revenue from './Revenue';
import Signup from './Signup';

const Open: React.FC = () => {
    const location = useLocation();
    const isLogin = security.isLogin;
    const { currentProcessStatus } = security;

    useMount(() => {
        const initPage = () => {
            const CACHE_KEY = getOpenCacheKey('esop');

            let cacheParams: object = {};

            // 页面加载后读取本地缓存的数据
            try {
                const sessionData = sessionStorage.getItem(CACHE_KEY);

                if (sessionData) {
                    cacheParams = JSON.parse(sessionData);
                }
            } catch {}

            // 当前开户流程组件挂载时初始化
            values.init(3, cacheParams, CACHE_KEY);
        };

        initPage();
    });

    const filterRouter = (
        routes = {
            contact: true,
            revenue: true,
            agreements: true,
            complete: true
        }
    ) => {
        const name = location.pathname.match(/(esop(\/\d+)?\/signup\/)([^/]+)/)?.[3];

        return !!name && routes[name];
    };

    return (
        <div>
            {!filterRouter() && <Progress type="fraction" />}
            <Routes>
                {
                    /* 注册结果页必须注册页前面声明 */
                    !isLogin && (
                        <>
                            <Route path=":regType?" element={<Signup />} />
                            <Route path="*" element={<Navigate to={{ ...location, pathname: '.' }} replace />} />
                        </>
                    )
                }

                {currentProcessStatus === CustomerProcessStatusEnum.UNACCOUNT && (
                    <>
                        <Route path="baseinfo" element={<BaseInfo />} />
                        <Route path="job" element={<Job />} />
                        <Route path="invest" element={<Invest />} />
                        <Route path="contact" element={<Contact />} />
                        <Route path="revenue" element={<Revenue />} />
                        <Route path="agreements" element={<Agreements />} />
                        <Route path="*" element={<Navigate to={{ ...location, pathname: 'baseinfo' }} replace />} />
                    </>
                )}

                {currentProcessStatus === CustomerProcessStatusEnum.AUDITING && (
                    <>
                        <Route path="complete" element={<Complete />} />
                        <Route path="*" element={<Navigate to={{ ...location, pathname: 'complete' }} replace />} />
                    </>
                )}

                <Route
                    path="*"
                    element={
                        <Navigate
                            to={{
                                ...location,
                                pathname: '/profile'
                            }}
                            replace
                        />
                    }
                />
            </Routes>
            <Footer />
        </div>
    );
};

export default observer(Open);
